module.exports = __webpack_public_path__ + "static/media/logo.6ba547c1.png";